import(/* webpackMode: "eager" */ "/app/src/entities/catalog-category/assets/maskbar.svg");
;
import(/* webpackMode: "eager" */ "/app/src/entities/catalog-category/assets/miniformat.svg");
;
import(/* webpackMode: "eager", webpackExports: ["CatalogCategoryPreview"] */ "/app/src/entities/catalog-category/ui/CatalogCategoryPreview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CatalogCategoriesAnimation"] */ "/app/src/features/catalog-categories-animation/ui/CatalogCategoriesAnimation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AboutFeatures"] */ "/app/src/widgets/about-section/ui/AboutFeatures.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AboutSection"] */ "/app/src/widgets/about-section/ui/AboutSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogPreviewSection"] */ "/app/src/widgets/blog-preview-section/ui/BlogPreviewSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductDetails"] */ "/app/src/widgets/product-details/ui/ProductDetails.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductTabs"] */ "/app/src/widgets/product-tabs/ui/ProductTabs.tsx");
